import {
  MarketContentCard, MarketLink,
} from '@market/react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { withI18n } from '@squareup/service-i18n/components';
import { CurrencyCode } from '@squareup/shared-types-protos/squareup/common/currency_codes';
import { formatCurrency } from '../../../../utils/format-currency';
import { PercentagePicker } from '../percentage-picker/PercentagePicker';
import { LearnMoreModal } from './LearnMoreModal';
import styles from './PortionOfSalesContent.module.css';

export interface PortionOfSalesContentProps {
  readonly percentage: number;
  readonly estimatedDailySalesAmountCents?: number;
  readonly onPercentageChange: (value: number) => void;
}

export const PortionOfSalesContent = ({
  percentage,
  onPercentageChange,
  estimatedDailySalesAmountCents,
}: PortionOfSalesContentProps) => {
  const { i18n } = useTranslation();
  const [isLearnMoreOpen, setIsLearnMoreOpen] = useState(false);

  const estimatedDailyRepaymentCents = estimatedDailySalesAmountCents
    ? Math.round(estimatedDailySalesAmountCents * (percentage / 100))
    : undefined;

  return (
    <div className={styles.content}>
      <p className="paragraph-30">
        <Trans
          i18nKey="bankingShared.creditCard.portionOfSales.subtitle"
          components={{
            learnMoreLink: (
              <MarketLink
                href="#"
                onClick={(e: React.MouseEvent) => {
                  e.preventDefault();
                  setIsLearnMoreOpen(true);
                }}
              />
            ),
          }}
        />
      </p>

      <PercentagePicker
        value={percentage}
        min={1}
        max={15}
        step={1}
        onChange={onPercentageChange}
      />

      {estimatedDailyRepaymentCents && (
        <MarketContentCard className={styles.estimateCard}>
          <Trans
            i18nKey="bankingShared.creditCard.portionOfSales.dailyEstimate"
            values={{
              estimatedAmount: formatCurrency({
                currencyValue: { amount: estimatedDailyRepaymentCents, currencyCode: CurrencyCode.USD },
                locale: i18n.language,
                includeMinor: false,
              }),
            }}
            components={{ bold: <strong /> }}
          />
        </MarketContentCard>
      )}

      <LearnMoreModal
        active={isLearnMoreOpen}
        percentage={percentage}
        onClose={() => setIsLearnMoreOpen(false)}
      />
    </div>
  );
};

export const PortionOfSalesContentI18n = withI18n(PortionOfSalesContent);
